export default {
  HOME: {
    CLASS: 'home-class',
    MODULE_CONTAINER: 'home-module-container',
    MODULE_CLASS: 'home-module-column',
    MODULE_IMAGE_CLASS: 'home-module-image',
    MODULE_HEADER_CLASS: 'home-module-header-container',
    MODULE_HEADER_TEXT_CLASS: 'home-module-header-text',
  },
};